import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { prettyDate } from '../../tools/date';
import postTranslations from '../../controllers/postTranslation';
import { getTickets, addTicket, deleteTicket } from '../../dbTickets';
import './TicketRow.scss';

export default class TicketRow extends Component {
  state = {
    ticketTranslated: '',
    loadingTicket: false,
  };

  statusIcon(status) {
    switch (status.name) {
      case 'New':
        return <i className="fa fa-clock-o ticket-clock fa-2x" />;
      case 'In progress': // in corso
        return <i className="fa fa-refresh ticket-refresh fa-spin fa-2x" />;
      case 'Closed': // chiuso
        return <i className="fa fa-check-circle-o ticket-check fa-2x" />;
      default:
        return null;
    }
  }

  ticketType(type) {
    switch (type) {
      case 4:
        return 'Insight';
      case 5:
        return 'General request';
      case 6:
        return 'On demand';
      default:
        return '';
    }
  }

  async componentDidMount() {
    const { subject, id, created_date } = this.props;
    const lang = localStorage.getItem('language').split('-')[0];
    if (lang !== 'it') {
      const dataTicket = await getTickets();
      if (dataTicket) {
        const currentTicket = dataTicket.find(tk => tk.idTicket === id);
        if (currentTicket) {
          this.setState({
            ticketTranslated: currentTicket?.translation?.title,
          });
        }
      }
      const checkData = dataTicket.find(tk => tk.idTicket === id);
      const checkDataByDate = checkData?.dateTicket !== created_date;
      if (!checkData || checkDataByDate) {
        this.setState({ loadingTicket: true });
        postTranslations({ title: subject }, lang).then(async res => {
          if (
            !res ||
            (res && res?.ok === false) ||
            (res && res?.status >= 400 && res?.status < 600)
          ) {
            this.setState({
              ticketTranslated: subject,
            });

            this.setState({ loadingTicket: false });
          } else {
            this.setState({
              ticketTranslated: res?.translation?.title,
            });

            if (dataTicket) {
              const checkData = dataTicket.find(tk => tk.idTicket === id);
              const checkDataByDate = dataTicket.find(
                tk => tk.idTicket === id && tk.dateTicket !== created_date
              );
              if (!checkData) {
                addTicket({
                  ...res,
                  idTicket: id,
                  dateTicket: created_date,
                });
              } else if (checkDataByDate) {
                deleteTicket(checkDataByDate.id);
                addTicket({
                  ...res,
                  idTicket: id,
                  dateTicket: created_date,
                });
              }
            }
            this.setState({ loadingTicket: false });
          }
        });
      }
    }
  }

  render() {
    const { id, created_date, subject, status_extra_info, type } = this.props;
    const { ticketTranslated, loadingTicket } = this.state;
    const lang = localStorage.getItem('language').split('-')[0];

    return (
      <li className="list-group-item">
        <div className="float-left">
          <h2>
            <Link to={`/ticket/${id}`}>
              {lang === 'it' || loadingTicket ? subject : ticketTranslated}
            </Link>
          </h2>
          <span className="ticket-type">{this.ticketType(type)}</span>
          <span className="date-label small">
            {' '}
            - {prettyDate(new Date(created_date))}
          </span>
          {loadingTicket && <p>translating...</p>}
        </div>
        <span className="btn btn-ligth btn-btnless float-right">
          {this.statusIcon(status_extra_info)}
        </span>
      </li>
    );
  }
}
